import { ButtonHTMLAttributes } from 'react';
import './Button.styles.scss';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

const Button: React.FC<ButtonProps> = (props) => {
  const { children, type = 'button', ...rest } = props;

  return (
    <button type={type} {...rest}>
      {children}
    </button>
  );
};

export default Button;
